import { createIntl } from 'react-intl'

import pkg from '../package.json'
// Default locale messages imported statically for initial render
import defaultMessages from '../src/lang-compiled/en-US.json'

const { supportedLocales: SUPPORTED_LOCALES } = pkg
export const DEFAULT_LOCALE = 'en-US'
export const LOCALES = SUPPORTED_LOCALES

const LOCALE_CONFIG = [
  { short: 'en', locale: 'en-US' },
  { short: 'fr', locale: 'fr-FR' },
  { short: 'ja', locale: 'ja-JP' },
  { short: 'de', locale: 'de-DE' },
  { short: 'nl', locale: 'nl-NL' },
  { short: 'es', locale: 'es-ES' },
]

async function getMessagesForLocale(locale: string) {
  if (locale === DEFAULT_LOCALE) {
    return defaultMessages
  }

  // Dynamic import for non-default locales
  return (await import(`../src/lang-compiled/${locale}.json`)).default
}

export const defaultIntl = createIntl({
  locale: DEFAULT_LOCALE,
  messages: defaultMessages,
})

export async function getMessagesFromLocale(
  locale: string
): Promise<Record<string, string>> {
  const config = LOCALE_CONFIG.find(
    (c) => c.locale === locale || c.short === locale
  )
  const resolvedLocale = config?.locale || DEFAULT_LOCALE
  return getMessagesForLocale(resolvedLocale)
}

export function extractLocale(urlPathname: string | undefined = '') {
  const path = urlPathname.split('/')

  let locale
  let urlPathnameWithoutLocale

  // We remove the URL locale, for example `/de-DE/about` => `/about` or `/de/about` => `/about`
  const first = path[1]
  const shortLocales = LOCALES.map((l: string) => l.split('-')[0])
  const allLocales = LOCALES.concat(shortLocales)

  if (allLocales.filter((l: string) => l !== DEFAULT_LOCALE).includes(first)) {
    // Convert short locale to full locale (e.g., 'fr' -> 'fr-FR')
    const matchedFullLocale = LOCALE_CONFIG.find(
      (c) => c.short === first || c.locale === first
    )?.locale
    locale = matchedFullLocale || DEFAULT_LOCALE
    urlPathnameWithoutLocale = `/${path.slice(2).join('/')}`
  } else {
    locale = DEFAULT_LOCALE
    urlPathnameWithoutLocale = urlPathname
  }

  return { locale, urlPathnameWithoutLocale }
}
